export const NOTIFICATION_CATEGORIES = [
  {
    id: 'messages',
    label: 'Messages',
    description: 'Inbox messages, board replies, and discussion updates.',
  },
  {
    id: 'events',
    label: 'Events',
    description: 'RSVPs, tickets, calendar changes, and waitlist places.',
  },
  {
    id: 'payments',
    label: 'Payments',
    description: 'Membership payments, refunds, and billing updates.',
  },
  {
    id: 'admin',
    label: 'Admin requests',
    description: 'Join requests, moderation, and club admin actions.',
  },
  {
    id: 'family_profile',
    label: 'Family and profile',
    description: 'Family invites, emergency contacts, and profile prompts.',
  },
  {
    id: 'rowing',
    label: 'Rowing updates',
    description: 'Outings, crews, boats, and Learn to Row updates.',
  },
];

export const DEFAULT_NOTIFICATION_CATEGORY_IDS = NOTIFICATION_CATEGORIES.map((category) => category.id);

const LEGACY_ACTION_CATEGORY_IDS = ['events', 'payments', 'family_profile', 'rowing'];

export function normalizeNotificationCategoryIds(categories, fallback = DEFAULT_NOTIFICATION_CATEGORY_IDS) {
  if (!Array.isArray(categories)) return [...fallback];
  const normalized = [];
  categories.forEach((rawCategory) => {
    const category = String(rawCategory || '').trim();
    const mappedCategories = category === 'actions' ? LEGACY_ACTION_CATEGORY_IDS : [category];
    mappedCategories.forEach((mappedCategory) => {
      if (
        DEFAULT_NOTIFICATION_CATEGORY_IDS.includes(mappedCategory)
        && !normalized.includes(mappedCategory)
      ) {
        normalized.push(mappedCategory);
      }
    });
  });
  return normalized;
}
